
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { MailsEditor } from "./MailsEditor";

export class RokojoriMails
{
  static readonly type = new ElementType( "rokojori-mails" );

  static applyOnDocument()
  {
    RokojoriMails.type.forAllInDoc( e => RokojoriMails.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let editor = new MailsEditor();
    editor.initialize( e );
  }


}